import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { openModal } from 'actions/common';
import { bindActionCreators } from 'redux';
import atoms from 'ctsutheme/components/atoms';
import { FasPlus } from 'assets/icons';
import { RenderElement } from 'components/RenderHelpers';
import _ from 'lodash';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import CreateEmbeddedNpStudy from 'containers/protocol/administration/embeddedNPStudy/CreateEmbeddedNpStudy';
import { ProtocolRelationsColumns } from '../gridcolumns';

const { Button } = atoms;

const ProtocolRelationsInfo = ({
  data,
  steps,
  setSteps,
  permission,
  addRelationsRow,
  addEmbeddedRow,
  editRelation,
  editEmbedded,
  protocolLogistics,
  saveProtocolRelations
}) => (
  <div className="grid-wide-toolbar">
    <GridTable
      tag={`${TE.ID}protrelandembstudy${TE.TABLE}`}
      title="Protocol Relations & Embedded Studies"
      exportTitle={`Protocol Relations & Embedded Studies-${useGetPathProtocol()}-OPENsetup`}
      columns={ProtocolRelationsColumns}
      user={GetUserFullName()}
      rows={data}
      filterable
      sortable
      rowEvents={[editRelation, editEmbedded]}
      enableToolbar
      defaultSorts={[{
        field: 'relatedProtocolNumber',
        dir: 'asc'
      }]}
      toPdf={false}
      renderCustomHeaderIcons={
        () => (
          <>
            <CreateEmbeddedNpStudy />
            <RenderElement access={permission}>
              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  name="addRelation"
                  data-id={`${TE.ID}protocol_relation${TE.BTN}`}
                  onClick={addRelationsRow}
                  className="turquoise ml-1"
                >
                  <FasPlus className="ml-n1 mr-1" />
                  Protocol Relation
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  name="addEmbed"
                  data-id={`${TE.ID}embedded${TE.BTN}`}
                  onClick={addEmbeddedRow}
                  className="turquoise ml-1"
                >
                  <FasPlus className="ml-n1 mr-1" />
                  Embedded Study
                </Button>
              </div>
            </RenderElement>
          </>

        )
      }
    />
  </div>
);

const withConnectState = connect(
  (state, ownProps) => ({}),
  dispatch => bindActionCreators(
    {
      onOpenModal: openModal
    },
    dispatch
  )
);

const ProtocolRelations = compose(
  withAppContext,
  withConnectState,
  withHandlers({
    openRelation: ({ onOpenModal }) => (title, data) => {
      onOpenModal({
        type: 'ProtocolRelations',
        title,
        modalSize: 'md',
        data
      });
    }
  }),
  withHandlers({
    addRelationsRow: ({ openRelation }) => () => {
      openRelation('Add Protocol Relation', { newRel: true });
    },
    editRelation: ({ openRelation }) => data => {
      openRelation('Modify Protocol Relation', data);
    }
  }),
  withHandlers({
    openEmbedded: ({ onOpenModal }) => (title, payload) => {
      onOpenModal({
        type: 'EmbeddedStudies',
        title,
        modalSize: 'md',
        data: payload
      });
    }
  }),
  withHandlers({
    addEmbeddedRow: ({ openEmbedded, data, protocolNumber }) => () => {
      const embData = _.filter(data, (item) => item.relatedProtocolNumber.indexOf(`${protocolNumber}-E-`) > -1);
      const dataLen = embData.length + 1;
      const relatedProtocolNumber = dataLen.toString().length === 1 ? `${protocolNumber}-E-0${dataLen}` : `${protocolNumber}-E-${dataLen}`;
      openEmbedded('Add Embedded Study', { relatedProtocolNumber });
    },
    editEmbedded: ({ openEmbedded }) => data => {
      openEmbedded('Modify Embedded Study', data);
    }
  })
)(ProtocolRelationsInfo);

export { ProtocolRelations };
